//$(document).bind('swiperight', function () {
//    history.back();
//});


function replaceBadChars(string) {
    //return string.replace(/[\/\\#~%'"*<>{}\[\]]/g, '');
    return String(string).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function flashObject(obj) {
    obj.addClass("flash");
    setTimeout(function () {
        obj.removeClass("flash");
    }, 1000);
}

function randomPassword() {
    const letters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const digits = '0123456789';
    const specialChars = '!$#%?+-~/';
    const allChars = letters + digits + specialChars;

    let password = [];

    // Mindestens 2 Buchstaben
    for (let i = 0; i < 2; i++) {
        password.push(letters[Math.floor(Math.random() * letters.length)]);
    }

    // Mindestens 1 Sonderzeichen
    password.push(specialChars[Math.floor(Math.random() * specialChars.length)]);

    // Mindestens 1 weitere Zahl oder Sonderzeichen (damit wir 2 Nicht-Buchstaben haben)
    const nonLetters = digits + specialChars;
    password.push(nonLetters[Math.floor(Math.random() * nonLetters.length)]);

    // Restliche Zeichen auff�llen bis mindestens 15
    while (password.length < 15) {
        password.push(allChars[Math.floor(Math.random() * allChars.length)]);
    }

    // Mischen
    password = password.sort(() => Math.random() - 0.5);

    // Sicherstellen, dass mindestens 5 unterschiedliche Zeichen enthalten sind
    const uniqueChars = new Set(password);
    if (uniqueChars.size < 5) {
        return generateTemporaryPassword(); // Rekursiv neu generieren
    }

    return password.join('');
}

function shuffle(string) {
    var parts = string.split('');
    for (var i = parts.length; i > 0;) {
        var random = parseInt(Math.random() * i);
        var temp = parts[--i];
        parts[i] = parts[random];
        parts[random] = temp;
    }
    return parts.join('');
}

function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href.toLowerCase();
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function prependTitle() {
    var contentContainer = $('#content-container');
    if (contentContainer) {
        //if (document.title) {
        //  contentContainer.prepend('<h1>' + document.title + '</h1>');
        //}
    }
}

function initCollapsible() {
    $('.collapse').on('show.bs.collapse', function (e) {
        var queryString = 'div[data-target="#' + e.target.id + '"] .expand-icon';
        //jQuery(queryString).fadeOut();
        toggleIcon(queryString);
    });

    $('.collapse').on('hide.bs.collapse', function (e) {
        var queryString = 'div[data-target="#' + e.target.id + '"] .expand-icon';
        //jQuery(queryString).fadeIn();
        toggleIcon(queryString);
    });
}

function toggleIcon(e) {
    $(e).toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
}

$(window).load(function () {
    if (getParameterByName('anchor') == "comm") {
        scrollToBottom();
    }
});

$(document).ready(function () {
    var start = 0;
    $('.footer-actionbar-like, .footer-actionbar-like > .modal > .modal-content > .circle > span').mousedown(function () {
        start = new Date();
    });
    $('.footer-actionbar-like, .footer-actionbar-like > .modal > .modal-content > .circle > span').mouseup(function (e) {
        var cur = new Date();
        var mainDiv = $(this).hasClass("footer-actionbar-like") ? $(this).parent() : $(this).parent().parent().parent().parent().parent();
        var pageid = $(mainDiv).attr("pageid");
        var paragraphid = $(mainDiv).attr("paragraphid");
        var binaryid = $(mainDiv).attr("binaryid");
        var react = 1;
        $(this).children().each(function () {
            if ($(this).hasClass("on")) react = 0;
        });
        var reaction = $(this).hasClass("footer-actionbar-like") ? react : $(this)[0].getAttribute("data-reaction");
        var obj = $(this).hasClass("footer-actionbar-like") ? $(this) : $(this).parent().parent().parent().parent();

        if ($(this).hasClass("footer-actionbar-like") && cur - start > 750) null;else {
            if (!e.target.classList.contains("modal")) setLikesForActionBar(obj, pageid, paragraphid, binaryid, -1, obj.find('.reaction-img' + reaction).hasClass("off") ? parseInt(reaction) : 0, obj.find('.reaction-img' + reaction));
            if (e.target.classList.contains("modal")) {
                e.target.style.display = "none";
                $('body').css("overflow", "auto");
            }
            if (e.target.parentElement.parentElement.parentElement.classList.contains("modal")) {
                e.target.parentElement.parentElement.parentElement.style.display = "none";
                $('body').css("overflow", "auto");
            }
        }
        e.stopPropagation();
    });

    $('.footer-actionbar-comment .comment-img').on('click', function () {

        var mainDiv = $(this).parent().parent();
        var pageid = $(mainDiv).attr("pageid");
        var paragraphid = $(mainDiv).attr("paragraphid");
        var binaryid = $(mainDiv).attr("binaryid");
        var commenttodo = $(mainDiv).attr("commenttodo");
        var empToken = $(mainDiv).attr("empToken");
        var uniqueKey = pageid + '_' + paragraphid + '_' + binaryid + '_-1';

        if (commenttodo == 'show') {
            $('.main_comment_section.' + uniqueKey).removeClass('off').addClass('on');

            var commentsOpen = $('.main_comment_section.' + uniqueKey).hasClass('on');

            if (commentsOpen) {
                $('.swiper-slide').css('height', '100%');
                //$('.main_comment_section.' + uniqueKey).find('.commentTextArea').focus();
                LoadComments(pageid, paragraphid, binaryid);
            } else {
                $('.swiper-slide').css('height', '100vh');
            }
        } else {
            window.location.href = "../default.aspx?pageid=" + pageid + "&emp_token=" + empToken + "&anchor=comm";
        }
    });

    $('.footer-actionbar-comment .likeCount').on('click', function () {

        var mainDiv = $(this).parent().parent().parent();
        var pageid = $(mainDiv).attr("pageid");
        var empToken = $(mainDiv).attr("empToken");

        window.location.href = "../default.aspx?pageid=" + pageid + "&emp_token=" + empToken + "&reaction=true";
    });

    $('.reaction-img1.reaction-actionbar-img1-stacked, .reaction-img2.reaction-actionbar-img2-stacked, .reaction-actionbar-img3-stacked, .reaction-actionbar-img4-stacked, .reaction-actionbar-img5-stacked').on('click', function () {

        var mainDiv = $(this).parent().parent();
        var pageid = $(mainDiv).attr("pageid");
        var empToken = $(mainDiv).attr("empToken");

        window.location.href = "../default.aspx?pageid=" + pageid + "&emp_token=" + empToken + "&reaction=true";
    });

    $('#root-container > .footer_actionbar .footer-actionbar-comment .comment-img').click();

    $('.footer-actionbar-comment .comment-text').on('click', function () {
        var mainDiv = $(this).parent().parent();
        var pageid = $(mainDiv).attr("pageid");
        var paragraphid = $(mainDiv).attr("paragraphid");
        var binaryid = $(mainDiv).attr("binaryid");
        var commenttodo = $(mainDiv).attr("commenttodo");
        var empToken = $(mainDiv).attr("empToken");
        var uniqueKey = pageid + '_' + paragraphid + '_' + binaryid + '_-1';

        if (commenttodo == 'show') {
            $('.main_comment_section.' + uniqueKey).removeClass('off').addClass('on');

            var commentsOpen = $('.main_comment_section.' + uniqueKey).hasClass('on');

            if (commentsOpen) {
                $('.swiper-slide').css('height', '100%');
                LoadComments(pageid, paragraphid, binaryid);
            } else {
                $('.swiper-slide').css('height', '100vh');
            }
        } else {
            window.location.href = "../default.aspx?pageid=" + pageid + "&emp_token=" + empToken + "&anchor=comm";
        }
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() > 150) {
            $('.scrollup').fadeIn();
        } else {
            $('.scrollup').fadeOut();
        }
    });

    $('.scrollup').click(function () {
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
    });
});

function scrollToBottom() {
    $('html, body').animate({
        scrollTop: $("#comm").offset().top
    }, 100);
}

function ScrollToObject(obj) {
    $("html, body").animate({ scrollTop: $(obj).offset().top }, 600);
    return false;
}

//function LoadComments(pageid, paragraphid, binaryid) {
//    var uniqueKey = pageid + '_' + paragraphid + '_' + binaryid;
//    //$(".comment-list." + uniqueKey).LoadingOverlay("show");

//    $.getJSON('VoteComment_ReweHandler.axd',
//        {
//            todo: 'GET_COMMENTLIST',
//            pageid: pageid,
//            paragraphid: paragraphid,
//            binaryid: binaryid
//        },
//        function (data) {
//            $('.comment-list.' + uniqueKey).html('');
//            if (data && data.length) {
//                var c = $('<ul class="comment-section ' + uniqueKey + '"></ul>');
//                for (var o in data) {
//                    var del = "";
//                    if (data[o].DeleteJN == 'J') {
//                        del = '<div class="del" commId="' + data[o].IdComm + '" pageId="' + pageid + '" paragraphId="' + paragraphid + '" binaryId="' + binaryid + '"></div>';
//                    }
//                    c.append(
//                        '<li class="comment user-comment ' + data[o].IdComm + '"><div class="info"><a href="#">' + data[o].ErstellUserName + '</a>' +
//                        del +
//                        '<span><time class="timeago" datetime="' + data[o].ErstellDatztString + '">' + data[o].ErstellDatztStringLong + '</time></span>' +
//                        '</div>' +
//                        '<div class="ctext"><p>' + data[o].Text.replace(/#br#/gi, '<br>') + '</p></div></li>');

//                }
//                c.append('<li><br /><br /></li>');

//                $('.comment-list.' + uniqueKey).append(c);

//                $("time.timeago").timeago();

//            } else {
//                $('.comment-list.' + uniqueKey).html('Es wurden keine Kommentare gefunden</br></br>');
//            }
//            //$(".comment-list." + uniqueKey).LoadingOverlay("hide");

//            if (paragraphid > -1 && $('.youVid.' + paragraphid).length) {
//                ScrollToObject('.youVid.' + paragraphid);
//            } else {
//                ScrollToObject('.main_comment_section.' + uniqueKey);
//            }
//        });
//}


function getCountersForActionBar(actionBar, pageid, paragraphid, binaryid, commid, ControlsToShow) {

    var vfooteractionbarlike = $(actionBar).find('.footer-actionbar-like');
    var vfooteractionbarcomment = $(actionBar).find('.footer-actionbar-comment');

    if (ControlsToShow.length > 0) {

        $(actionBar).show();
        ~ControlsToShow.indexOf('L') != 0 ? vfooteractionbarlike.show() : vfooteractionbarlike.hide();
        ~ControlsToShow.indexOf('C') != 0 ? vfooteractionbarcomment.show() : vfooteractionbarcomment.hide();

        getCountersForActionBar_handlerCall(actionBar, pageid, paragraphid, binaryid, commid);
    } else {
        $(actionBar).hide();
    }
}

function getCountersForActionBar_handlerCall(actionBar, pageid, paragraphid, binaryid, commid) {
    $.getJSON('VoteComment_ReweHandler.axd', {
        todo: 'GET_COUNTER',
        pageid: pageid,
        paragraphid: paragraphid,
        binaryid: binaryid,
        commid: commid
    }, function (data) {
        if (data) {
            for (var o in data) {
                if (data[o].Type == "Reaction") {
                    let likeCount = data[o].Count;
                    $(actionBar).parent().find('.likeCount').html(likeCount);
                    //$(actionBar).parent().find('.likeText').html(data[o].Text); //vorl�ufig kein Text
                    if (data[o].ReactedWith != -1) {
                        $(actionBar).find('[class*=reaction-img]').removeClass('on').addClass('off');
                        $(actionBar).find('[class*=reaction-actionbar-img]').css("display", "none");
                        $(actionBar).find('.reaction-actionbar-img' + data[o].ReactedWith).css("display", "inline-block");
                        $(actionBar).find('.reaction-actionbar-img' + data[o].ReactedWith).removeClass('off').addClass('on');
                        $(actionBar).children().find('.reaction-img' + data[o].ReactedWith).removeClass('off').addClass('on');
                    } else {
                        $(actionBar).children().find('[class*=reaction-img]').removeClass('on').addClass('off');
                        $(actionBar).find('[class*=reaction-actionbar-img]').removeClass('on').addClass('off');
                        $(actionBar).find('[class*=reaction-actionbar-img]').css("display", "none");
                        $(actionBar).find('.reaction-actionbar-img1').css("display", "inline-block");
                    }
                    for (var i = 1; i <= 5; i++) {
                        var reactionCount = data[o]['ReactionCount' + i];
                        var sel = '.reaction-actionbar-img' + i + '-stacked';
                        actionBar.parent().find(sel).toggleClass('off', reactionCount <= 0).toggleClass('on', reactionCount > 0);
                        if (reactionCount > 0 || i == 1) {
                            actionBar.parent().find(sel).css("display", "inline-block");
                        }
                    }
                    let trans = 0;
                    for (var i = 5; i >= 1; i--) {
                        if (actionBar.parent().find('[class*="reaction-actionbar-img' + i + '-stacked"]').css('display') === 'inline-block') {
                            actionBar.parent().find('[class*="reaction-actionbar-img' + i + '-stacked"]').css('transform', 'translateX(' + trans + '%)');
                            trans += 70;
                        }
                    }
                }
                if (data[o].Type == "Comment") {
                    $(actionBar).find('.commentCount').html(data[o].Count);
                    $(actionBar).find('.commentText').html(data[o].Text);

                    if (data[o].HaveCommented == "J") {
                        $(actionBar).find('.comment-img').removeClass('off').addClass('on');
                    } else {
                        $(actionBar).find('.comment-img').removeClass('on').addClass('off');
                    }
                }
            }
        }
    });
}

function setLikesForActionBar(actionBar, pageid, paragraphid, binaryid, commid, count, actionBarIcon) {

    $.post('VoteComment_ReweHandler.axd', {
        todo: 'SET_VOTE',
        pageid: pageid,
        paragraphid: paragraphid,
        binaryid: binaryid,
        commid: commid,
        count: count
    }, function (data) {
        if (data && data != "NOK") {
            getCountersForActionBar_handlerCall(actionBar, pageid, paragraphid, binaryid, commid);
            actionBarIcon.toggleClass('on off');
        }
    });
}

function checkSearchInput(searchTerm) {

    if (searchTerm.length >= 0 && searchTerm.length < 3) {
        $.confirm({
            animation: 'top',
            columnClass: 'col-md-12',
            closeAnimation: 'top',
            title: translationSuchergebnisListe["5397"],
            content: translationSuchergebnisListe["5398"],
            type: 'blue',
            typeAnimated: true,
            buttons: {
                confirm: {
                    text: translationSuchergebnisListe["5499"],
                    action: function () {}
                }
            }
        });
        return false;
    }
    return true;
}

function noSearchResultFound() {
    $.confirm({
        animation: 'top',
        columnClass: 'col-md-12',
        closeAnimation: 'top',
        title: translationSuchergebnisListe["5399"],
        content: translationSuchergebnisListe["5400"],
        type: 'blue',
        typeAnimated: true,
        buttons: {
            confirm: {
                text: translationSuchergebnisListe["5499"],
                action: function () {}
            }
        }
    });
}